import React from 'react';
import { Navigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useGoogleLogin } from 'react-google-login';

import { SignUpLayout } from '@thinknet-gmbh/platform-common-ui';
import { PlatformModulesEnum } from '@thinknet-gmbh/platform-common';

import { useRouteQuery } from 'src/common/helpers';
import { AUTH_SUB_PAGES } from 'src/pages/auth/auth.constants';
import { ROUTES } from 'src/components/app/app-routes.constants';
import { useAuthAxiosInstance } from 'src/pages/auth/auth.axios.instance';

const SignUp: React.FC = () => {
  const { t } = useTranslation(['auth', 'common']);

  const { googleAuth, microsoftAuth } = useAuthAxiosInstance();
  const { signIn } = useGoogleLogin({
    onSuccess: googleAuth,
    clientId: process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID || '',
  });

  const query = useRouteQuery();
  const token: string = query.get('token') || '';

  const { resetPassword } = useAuthAxiosInstance({ externalAccessToken: token });

  if (!token) {
    return <Navigate to={{ pathname: `${ROUTES.auth}/${AUTH_SUB_PAGES.verification}` }} />;
  }

  return (
    <SignUpLayout
      t={t}
      googleAuth={signIn}
      microsoftAuth={microsoftAuth}
      module={PlatformModulesEnum.PLAN_WERK_MODULE}
      resetPassword={resetPassword}
    />
  );
};

export default SignUp;
